import { promisify } from "./utils/Promisify";

function saveDraftFnDescriptor(
  switchValue: string,
  executeCondition: string,
  triggerSetting: string,
  debounceAndThrottleTime: number,
) {
  return {
    type: "SAVE_DRAFT" as const,
    payload: {
      switchValue,
      executeCondition,
      triggerSetting,
      debounceAndThrottleTime
    },
  };
}

export type TSaveDraftArgs = Parameters<typeof saveDraftFnDescriptor>;
export type TSaveDraftDescription = ReturnType<typeof saveDraftFnDescriptor>;
export type TSaveDraftActionType = TSaveDraftDescription["type"];

async function saveDraft(...args: Parameters<typeof saveDraftFnDescriptor>) {
  return promisify(saveDraftFnDescriptor)(...args);
}

function restoreDraftFnDescriptor(
  switchValue: string,
  executeCondition: string,
  triggerSetting: string,
  debounceAndThrottleTime: number,
) {
  return {
    type: "RESTORE_DRAFT" as const,
    payload: {
      switchValue,
      executeCondition,
      triggerSetting,
      debounceAndThrottleTime
    },
  };
}

export type TRestoreDraftArgs = Parameters<typeof restoreDraftFnDescriptor>;
export type TRestoreDraftDescription = ReturnType<typeof restoreDraftFnDescriptor>;
export type TRestoreDraftActionType = TRestoreDraftDescription["type"];

async function restoreDraft(...args: Parameters<typeof restoreDraftFnDescriptor>) {
  return promisify(restoreDraftFnDescriptor)(...args);
}

function deleteDraftFnDescriptor(
  switchValue: string,
  executeCondition: string,
  triggerSetting: string,
  debounceAndThrottleTime: number,
) {
  return {
    type: "DELETE_DRAFT" as const,
    payload: {
      switchValue,
      executeCondition,
      triggerSetting,
      debounceAndThrottleTime
    },
  };
}

export type TDeleteDraftArgs = Parameters<typeof deleteDraftFnDescriptor>;
export type TDeleteDraftDescription = ReturnType<typeof deleteDraftFnDescriptor>;
export type TDeleteDraftActionType = TDeleteDraftDescription["type"];

async function deleteDraft(...args: Parameters<typeof deleteDraftFnDescriptor>) {
  return promisify(deleteDraftFnDescriptor)(...args);
}

export { saveDraft, restoreDraft, deleteDraft };
